import { render } from "./CustomerInvitationPage.vue?vue&type=template&id=64fd35f0"
import script from "./CustomerInvitationPage.vue?vue&type=script&lang=js"
export * from "./CustomerInvitationPage.vue?vue&type=script&lang=js"

import "./CustomerInvitationPage.vue?vue&type=style&index=0&id=64fd35f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__